export default __webpack_public_path__ + "static/media/bg-dark7.d343f4a1.jpg";